export default __webpack_public_path__ + "static/media/TapRead.1cff8042.png";